
    import { Component, Vue } from "vue-property-decorator";
    import type { Location } from "vue-router";
    import StakingTab from "@/components/StakingTab.vue";
    import VueUtils from "@/cuties/VueUtils";
    import PlayerEnvironment from "@/cuties/player/PlayerEnvironment";

    @Component({
        components: { StakingTab },
    })
    export default class Staking extends Vue {
        tab = "BCUG";
        tabs = ["BCUG", "ETH-BCUG"];
        tooltipOpenDelay: number = VueUtils.tooltipOpenDelay;
        tooltipCloseDelay: number = VueUtils.tooltipCloseDelay;

        created(): void {
            this.tab = this.$route.query.tab ? (this.$route.query.tab as string) : this.tab;
        }

        changeTab(tab: string): void {
            this.tab = tab;
            this.pushHistory();
        }

        coinName(tab: string): string {
            return this.$t("token-name-" + tab).toString();
        }

        getEnv(): PlayerEnvironment {
            return PlayerEnvironment;
        }

        pushHistory(): void {
            this.$router.push(this.prepareHistoryEntry());
        }

        prepareHistoryEntry(): Location {
            return {
                path: "/" + this.$i18n.locale + "/bcug",
                query: {
                    tab: this.tab,
                },
            };
        }
    }
